import React from "react";
import { twMerge } from "tailwind-merge";

export type BadgeAppearance = "soft" | "outline";

export type BadgeProps = {
  className?: string;
  variant?: keyof typeof variantSoftStyles;
  text: string | React.ReactNode;
  appearance?: BadgeAppearance;
};

const variantSoftStyles = {
  success: "bg-green-100 text-green-800",
  warning: "bg-yellow-100 text-yellow-800",
  error: "bg-red-100 text-red-700",
  unknown: "bg-gray-100 text-gray-700",
  info: "bg-blue-100 text-blue-600",
};

const variantOutlineStyles = {
  success: "bg-white text-green-800 border-green-800",
  warning: "bg-white text-yellow-700 border-yellow-700",
  error: "bg-white text-red-700 border-red-700",
  unknown: "bg-white text-gray-700 border-gray-700",
  info: "bg-white text-blue-600 border-blue-200",
};

export const Badge = ({
  className,
  variant = "success",
  text,
  appearance = "soft",
}: BadgeProps) => {
  const styles =
    appearance === "outline" ? variantOutlineStyles : variantSoftStyles;
  return (
    <span
      className={twMerge(
        "inline-flex w-fit items-center justify-center rounded-md px-2 py-1 text-xs font-medium",
        appearance === "outline" && "border",
        styles[variant],
        className,
      )}
    >
      {text}
    </span>
  );
};
